<template>
  <b-table class="mt-2" striped hover :fields="fields" :items="rows">
  </b-table>
</template>

<script>
import articles from '@/modules/articles.js'

export default {
  name: 'ArticlePrices',
  props: ["priceid"],
  data() {
    return {
      fields: [
        {label:"ID",key:"map_id"},
        {label:"Liste",key:"list_id"},
        {label:"Artikel-Ref",key:"art_id"},
        {label:"Preis",key:"price"},
        {label:"Währung",key:"curr"}
      ],
      rows: []
    }
  },
  watch: {
    priceid: function() { console.log('watch:' + this.priceid); this.fetchData(); }
  },
  methods: {
    fetchData: function() {
      var self = this;
      articles.prices(this.priceid,function(data) {
        self.rows = data;
      })
    }
  }
}
</script>
